import React from "react";
import samplePic from "../../assets/med_real.jpg";

function Tips() {
  return (
    <div className="tips-container page-max-width">
      <h2>Tips</h2>
      <ul>
        <li>
          This authenticator currently works best on classic medium sized badges
          and black label badges. For classic red and white labels, the
          authenticator is close to 90% accurate, and about ~70% accurate for
          black labels. For other badge varients, or for a human opinion, we'd
          suggest checking out our friends at the{" "}
          <a href="https://www.reddit.com/r/CanadaGoose/">
            Canada Goose Subreddit
          </a>{" "}
          .
        </li>
        <li>
          If the authenticator is not finding a label in your image, try to{" "}
          <b>crop your image</b> down like so: <br></br>
          <img src={samplePic} style={{ maxWidth: "200px" }} />
        </li>

        <li>
          Make sure the image <b>shows the badge clearly</b>, at a good angle,
          and with good lighting.{" "}
        </li>
      </ul>
      <p>*Submitted images are collected to help improve model accuracy.*</p>
    </div>
  );
}

export default Tips;
